import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Data } from '../types/data';
import { DataVote } from '../types/date-vote';
import { DataNewNames } from '../types/date-new-names';
import { DataLogin } from '../types/data-login';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NwvoteService {
  private readonly webBaseUrl =
    'https://tools.brandinstitute.com/wsGeneral/wsNWVote.asmx/';

  private readonly baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  data: Data = {
    token: '38230499-A056-4498-80CF-D63D948AA57F',
    project: '',
    username: '',
    userToken: '',
  };

  dataVote: DataVote = {
    token: '38230499-A056-4498-80CF-D63D948AA57F',
    project: '',
    username: '',
    userToken: '',
    name: '',
    vote: '',
  };

  dataNewNames: DataNewNames = {
    token: '38230499-A056-4498-80CF-D63D948AA57F',
    project: '',
    username: '',
    userToken: '',
    newNames: '',
  };

  dataLogin: DataLogin = {
    token: '38230499-A056-4498-80CF-D63D948AA57F',
    project: '',
    username: '',
    name: '',
    summarize: '',
  };

  getName() {
    this.data.project = localStorage.getItem('project');
    this.data.username = localStorage.getItem('username');
    this.data.userToken = localStorage.getItem('userTokenId');
    return this.http.post(this.webBaseUrl + 'GetVotingInfo', this.data);
  }

  voteName(name: string, vote: string) {
    this.dataVote.name = name;
    this.dataVote.vote = vote;
    this.dataVote.username = localStorage.getItem('username');
    this.dataVote.project = localStorage.getItem('project');
    this.dataVote.userToken = localStorage.getItem('userTokenId');
    return this.http.post(this.webBaseUrl + 'SaveVotingInfo', this.dataVote);
  }

  newNamesSuggestions(name: string, newNames: string[]) {
    this.dataNewNames.newNames = newNames.length === 1 ? newNames[0] : newNames.join(';');
    this.dataNewNames.username = localStorage.getItem('username');
    this.dataNewNames.project = localStorage.getItem('project');
    this.dataNewNames.userToken = localStorage.getItem('userTokenId');
    return this.http.post(this.baseUrl+'SaveNewNamesFromVoteApp', this.dataNewNames);
  }

  login(data: any, project: string) {
    this.dataLogin.username = data.email;
    this.dataLogin.name = data.name;
    this.dataLogin.project = project;
    this.dataLogin.summarize = data.suma ? '1' : '0';
    return this.http.post(this.webBaseUrl + 'AuthorizeUser', this.dataLogin);
  }
}
